import { Star } from "lucide-react";

export default function StarRating({ rating = 5, size = 14, className = "" }) {
  return (
    <div className={`flex items-center gap-0.5 ${className}`} aria-label={`Rated ${rating} out of 5`}>
      {[1, 2, 3, 4, 5].map((i) => (
        <Star
          key={i}
          size={size}
          className={i <= Math.round(rating) ? "fill-[#D4AF37] text-[#D4AF37]" : "text-white/25"}
        />
      ))}
    </div>
  );
}
